import React from 'react';
import { Modal, Table } from '@amzn/awsui-components-react/polaris';
import './MemoryBreakdownModal.css';
import MemoryBar from './MemoryBar';
import { SECTIONS } from './const';
import CopyToClipboardButton from '../copyToClipboardButton';
import { useCollection } from '@amzn/awsui-collection-hooks';
import { BrokerInstanceMemoryBreakdown, EC2Instance } from '@amzn/amazonmq-opsconsole-client';

type Props = {
    open: boolean,
    instance: EC2Instance,
    instanceMemoryBreakdown: BrokerInstanceMemoryBreakdown,
    onClose: () => void
}

type TableRow = {
    fieldName: string;
    fullName: string;
    valueInGb: number;
    percentage: number;
} 

const MemoryBreakdownModal : React.FC<Props> = ({open, instance, instanceMemoryBreakdown, onClose}) => {

      
    let valueAsText = "";
    let tableRows: TableRow[] = [];
    let breakdown : any = instanceMemoryBreakdown.memoryBreakdown;
    let totalBytesUsed : number = 0.0;
    for (let key in instanceMemoryBreakdown.memoryBreakdown) {
        totalBytesUsed += breakdown[key].bytes;
    }

    for (let key in instanceMemoryBreakdown.memoryBreakdown) {
        let valueInBytes : number = breakdown[key].bytes;
        let valueInGb : number = valueInBytes / Math.pow(10, 9);
        tableRows.push({
            fieldName: key,
            valueInGb: valueInGb,
            percentage: breakdown[key].percentage,
            fullName: SECTIONS[key] ? SECTIONS[key][1] : key
        })
        valueAsText += `${key}: ${valueInGb.toFixed(5)} gb (${(breakdown[key].percentage).toFixed(2)}%)\n`
    }

    const {
        items,
        collectionProps
      } = useCollection(tableRows ?? [], {
        filtering: {},
        sorting: {
          defaultState: {
            sortingColumn: {
                sortingField: 'percentage',
            },
            isDescending: true,
          },
        },
      });

    return (
        <Modal 
            size="large"
            header={`${instance.instanceId} Memory Breakdown`}
            visible={open}
            onDismiss={() => {
                onClose();
            }}
        >
            <div style={{display: 'flex', flexDirection: 'column', gap: 8}}>
                <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                    <MemoryBar data={instanceMemoryBreakdown} />
                    <div style={{flexGrow: 1}}></div>
                    <CopyToClipboardButton text={valueAsText} />
                </div>
                <div style={{maxHeight: 500, overflow: 'scroll'}}>
                <Table
                    {...collectionProps}
                    items={items}
                    wrapLines={true}
                    columnDefinitions={[
                        {
                            id: "Color",
                            header: "",
                            width: 15,
                            cell: (item: TableRow) => {
                                if (SECTIONS[item.fieldName]) {
                                    return  <div style={{width: 15, height: 15}} className={`memory-section memory_${SECTIONS[item.fieldName][0]}`}></div>
                                } else {
                                    return <></>
                                }
                            }
                        },
                        {
                            id: "Name",
                            header: "Name",
                            cell: (item: TableRow) => item.fullName
                        },
                        {
                            id: "field",
                            header: "Field",
                            cell: (item: TableRow) => item.fieldName
                        },
                        {
                            id: "valueInGb",
                            header: "Memory Used (gb)",
                            cell: (item: TableRow) => item.valueInGb.toFixed(5),
                            sortingField: 'valueInGb'
                        },
                        {
                            id: "percentage",
                            header: "%",
                            cell: (item: TableRow) => `${(item.percentage).toFixed(2)}%`,
                            sortingField: 'percentage',
                        }
                    ]}
                />
                </div>
            </div>
        </Modal>
    )
}

export default MemoryBreakdownModal;